import { render, staticRenderFns } from "./MyExtruderMachineDetails.vue?vue&type=template&id=1d4598b2&"
import script from "./MyExtruderMachineDetails.vue?vue&type=script&lang=js&"
export * from "./MyExtruderMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./MyExtruderMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports